import { ReactNode } from "react";
import { create } from "zustand";

type ResponsiveState = {
  device: "mobile" | "desktop";
  setDevice: (device: "mobile" | "desktop") => void;

  mobileMenuOpen: boolean;
  toggleMenu: () => void;
  closeMenu: () => void;

  menuComponent?: ReactNode;
  setMenuComponent: (component: ReactNode) => void;
};

export const useResponsiveStore = create<ResponsiveState>((set) => ({
  device: window.innerWidth < 800 ? "mobile" : "desktop",
  setDevice: (device) => set({ device: device }),

  mobileMenuOpen: false,
  toggleMenu: () => set((state) => ({ mobileMenuOpen: !state.mobileMenuOpen })),
  closeMenu: () => set({ mobileMenuOpen: false }),

  menuComponent: null,
  setMenuComponent: (component) => set({ menuComponent: component }),
}));